require("./sort-options.scss");

(function ($) {

    $(() => {
        const elm = $(".sorting-options");

        elm.click((e) => {
            e.stopPropagation();
            elm.toggleClass("open");
        });

        $(document.body).click(() => elm.removeClass("open"));
    });

})(jQuery);